import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ipify = defineConnector({
  identifier: "ipify",
  name: "Ipify",
  tagLine: "Public IP address API",
  logo,
  protocol: "http",
  tags: ["data", "it"],
  defaultUrlPattern: () => "https://api(?:64|6)?\\.ipify\\.org/.*",
  auth: customAuth("noop"),
  steps: [
    {
      title: "No credentials required",
      items: [
        {
          kind: "markdown",
          content:
            "Ipify is a public API for discovering the caller's IP address. No API key or account setup is required.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api64.ipify.org?format=json",
  },
});
